import React from "react";
import { Wrapper } from "./styles";
import { SubHeaderViewProps } from "./types";

export const SubHeaderView = (props: SubHeaderViewProps) => {
	return <React.Fragment>{props.children && <Wrapper>{props.children}</Wrapper>}</React.Fragment>;
};
